export class EventBusService {
  events = new Map();

  constructor(pmv3MessageHubEventService) {
    pmv3MessageHubEventService.initializeMessageListener((channel, data) => {
      this.events.set(channel, data);
    });
  }

  initializeChannel(message, channel) {
    this.events.set(channel, message);
  }

  getMessageByChannel(channelName) {
    return this.events.get(channelName);
  }
}
